import Application from "../../Application";
import GenericCodebookPresenter, {
  IGenericCodebookPresenter
} from "../presenter/GenericCodebookPresenter";
import { ICodebookService } from "../service/CodebookService";

export default class ShowGenericCodebookInteractor {
  private application: Application;
  private codebookService: ICodebookService;
  private output?: IGenericCodebookPresenter;

  constructor({ application, codebookService }: any) {
    this.application = application;
    this.codebookService = codebookService;
  }

  execute(codebookTypeName: string) {
    this.output = GenericCodebookPresenter({
      application: this.application,
      initialState: {
        codebookTypeList: [],
        selectedCodebook: codebookTypeName,
        codebookItemList: [],
        itemModalVisible: false
      }
    });

    this.codebookService
      .getGenericCodebook(codebookTypeName, true)
      .then(this.output && this.output.loadCodebookItemsList);

    return this.output;
  }
}
